<template>
  <div v-if="!mobileCheck()">
    <Minting/>
    <div class="Container">
      <ContentTop :activeKey="1" @searchData="searchData"/>
      <NodeList
        :tableData="nodeList"
        :tokensList="tokensList"/>
      <!-- <p class="text">
        <span class="star">*</span>Special conditions may apply. Please visit delegation service website for details</p> -->
    </div>
  </div>
  <div v-else>
    <Minting/>
    <div class="mcontainer">
      <NodeList :tableData="nodeList"/>
    </div>
  </div>
</template>

<script>
  import ContentTop from '@/components/commons/ContentTop';
  import Minting from '@/components/commons/Minting';
  import { mobileCheck } from '@/utils/common';
  import NodeList from '@/components/table/NodeList';
  import { mapState } from 'vuex';

  export default {
    name: 'Home',
    components: {
      ContentTop,
      NodeList,
      Minting,
    },
    created() {
      this.$store.dispatch('nodes/getNodeList');
      this.$store.dispatch('nodes/getTokensList');
    },
    computed: {
      ...mapState('nodes', {
        nodeList: 'nodeList',
        allList: 'allList',
        tokensList: 'tokensList',
      }),
    },
    methods: {
      mobileCheck() {
        return mobileCheck();
      },
      searchData(kd) {
        const allData = this.allList;
        const payload = {};
        if (!kd) {
          payload.nodeList = allData;
        } else {
          const searchList = [];
          const len = allData.length;
          for (let i = 0; i < len; i += 1) {
            const item = allData[i];
            if (item.name.toUpperCase().indexOf(kd.toUpperCase()) > -1
              || item.address.toUpperCase().indexOf(kd.toUpperCase()) > -1) {
              searchList.push(item);
            }
          }
          payload.nodeList = searchList;
        }
        this.$store.commit('nodes/saveSearch', payload);
      },
    },
  };
</script>

<style>
  .text {
    color: #7D7D80;
    font-size: 15px;
    margin-top: 40px;
  }
  .star{
    color: #F5354B;
  }
  .mcontainer{
    padding: 0.2rem 0.15rem 0.24rem 0.15rem;
  }
</style>
